import { MouseEventHandler } from 'react';

import TextBaseFieldPlaceholder, {
  TextBaseFieldPlaceholderProps,
} from '@app/features/apply-react-signing/components/FieldSetupStep/Placeholders/TextBaseFieldPlaceholder';

export interface SigningDateFieldPlaceholderProps
  extends Omit<TextBaseFieldPlaceholderProps, 'value'> {
  dateFormat: string;
}

const defaultProps = {
  rootElementSize: null,
  onMouseDown(_event: MouseEventHandler<HTMLDivElement>) {},
};

function SigningDateFieldPlaceholder({ dateFormat, ...props }: SigningDateFieldPlaceholderProps) {
  return <TextBaseFieldPlaceholder {...props} value={`#${dateFormat}`} />;
}

SigningDateFieldPlaceholder.defaultProps = defaultProps;

export default SigningDateFieldPlaceholder;
